/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type prospectkpis_ProspectKpiDropOffByStatusResponse = {
    /**
     * Count is the number of archive events out of that stage.
     */
    count: number;
    /**
     * FromStatus is the pipeline stage the prospect dropped out of. ARCHIVED appears when a
     * prospect was archived straight out of an earlier archive (a re-archive).
     */
    from_status: prospectkpis_ProspectKpiDropOffByStatusResponse.from_status;
};
export namespace prospectkpis_ProspectKpiDropOffByStatusResponse {
    /**
     * FromStatus is the pipeline stage the prospect dropped out of. ARCHIVED appears when a
     * prospect was archived straight out of an earlier archive (a re-archive).
     */
    export enum from_status {
        NEW = 'NEW',
        IN_PROGRESS = 'IN_PROGRESS',
        TOUR_SCHEDULED = 'TOUR_SCHEDULED',
        TOUR_COMPLETED = 'TOUR_COMPLETED',
        FOLLOW_UP_OPEN = 'FOLLOW_UP_OPEN',
        CONTRACT_SENT = 'CONTRACT_SENT',
        CONTRACT_SIGNED = 'CONTRACT_SIGNED',
        ACTIVE = 'ACTIVE',
        ARCHIVED = 'ARCHIVED',
    }
}

